// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LeaderboardPage_wrapper_2vqfM"};